import { render, staticRenderFns } from "./TalentWizard.vue?vue&type=template&id=b0a2d1aa"
import script from "./TalentWizard.vue?vue&type=script&lang=js"
export * from "./TalentWizard.vue?vue&type=script&lang=js"
import style0 from "./TalentWizard.vue?vue&type=style&index=0&id=b0a2d1aa&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports